<template>
   <div class="card shadow h-100">
    <div class="card-header bg-transparent border-0">
      <h6>Lista</h6>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" :class="tabSelecionado == 'inserido' ? 'active' : '' " href="#" @click="tab('inserido')">Inseridos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="tabSelecionado == 'removido' ? 'active' : '' " href="#" @click="tab('removido')">Removidos</a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="alert alert-success fade show" role="alert" v-show="msgSuccess.length > 0">
        <div v-for="(msg, i) in msgSuccess" v-bind:key="i">{{msg}}
        </div>
      </div>
      
      <div class="alert alert-danger fade show" role="alert" v-show="erros.length > 0">
        <div v-for="(erro, i) in erros" v-bind:key="i">{{erro}}</div>
      </div>
      <div v-if="listaObjeto.length  == 0">Nenhum item encontrado</div>
      <div
        class="table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl"
        style="max-height:500px; overflow-y: auto"
        v-else
      >
        <table
          class="table table-borderless table-hover table-sm table-md table-lg table-xl table-condensed"
        >
          <thead>
            <tr class="d-flex">
              <th class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1" v-show="tabSelecionado != 'inserido'">Data Deleção</th>
              <th class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1" v-show="tabSelecionado == 'inserido'">Ação</th>
              <th class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1">Situação</th>
              <th class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">Motivo</th>
              <th class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">Outro Motivo</th>
              <th class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">Início Vigência</th>
              <th class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">Fim Vigência</th>
            </tr>
          </thead>
          <tbody>
            <tr class="d-flex" v-for="(objeto) of listaObjeto" v-bind:key="objeto.id">
              
              <td
                class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1"  v-show="tabSelecionado != 'inserido'"
              >{{objeto.data_delecao | formatDatetime}}</td>
              <td class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1" v-show="tabSelecionado == 'inserido'">
                <button
                  type="button"
                  class="btn btn-xl btn-lg btn-md btn-sm btn-info"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Editar Licença"
                  v-show="objeto.permite_editar == 1"
                  @click="showModalEdit(objeto)"
                >
                  <li class="oi oi-pencil"></li>
                </button>
                <button
                  type="button"
                  class="btn btn-xl btn-lg btn-md btn-sm btn-danger"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Excluir Licença"
                  v-show="objeto.permite_deletar == 1"
                  @click="showModal(objeto)"
                >
                  <li class="oi oi-trash"></li>
                </button>
              </td>
              <td class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1">
                <span
                  class="badge badge-mod-success"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Licença aprovada"
                  v-if="objeto.situacao == 'Aprovado'"
                >
                  <li class="oi oi-check"></li>Aprovada
                </span>
                
                <span
                  class="badge badge-mod-danger"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Licença removida"
                  v-else-if="objeto.situacao == 'Removido'"
                >
                  <li class="oi oi-trash"></li> Removido
                </span>
                
                <span
                  class="badge badge-mod-info"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Licença será reenviada em instantes"
                  v-else-if="objeto.situacao == 'Aguardando Reenvio'"
                >
                  <li class="oi oi-clock"></li>{{objeto.situacao}}
                </span>
                <span
                  class="badge badge-mod-warning"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Licença será aprovada somente no dia seguinte"
                  v-else
                >
                  <li class="oi oi-clock"></li>Aguardando Aprovação
                </span>
              </td>
              <td class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">{{objeto.motivo}}</td>
              <td class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">{{objeto.outro_motivo_licenca}}</td>
              <td class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">{{objeto.data_inicio_vigencia | formatDateMonthYear}}</td>
              <td class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">{{objeto.data_fim_vigencia | formatDateMonthYear}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <modal v-show="isModalVisible" @close="closeModal">
      <span slot="header">Deleção de Licença Previdenciária</span>
      <div slot="body">
        
        <div class="row">
          <div class="col-11">
            <label class="label-black">Deseja realmente efetuar a deleção da licença?</label>
          </div>
        </div>
        <br/>
        <div class="row">
          <div class="col-11">
            <label class="label-black">Início Vigência:</label>
            <span>{{objeto.data_inicio_vigencia | formatDateMonthYear}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-11">
            <label class="label-black">Fim Vigência:</label>
            <span>{{objeto.data_fim_vigencia | formatDateMonthYear}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-11">
            <label class="label-black">Motivo:</label>
            <span>{{objeto.motivo}}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-danger" @click="closeModal()">
        <li class="oi oi-circle-x"></li> Não
      </button>
      <button class="btn btn-secondary" @click="deletarObjeto()">
        <li class="oi oi-check"></li> Sim
      </button>
      </div>
    </modal>
    
    <modal v-show="isModalVisibleEdit" @close="closeModalEdit">
      <span slot="header">Alteração de Licença Previdenciária</span>
      <div slot="body">
        
        <div class="row">
          <div class="col-11">
            <label class="label-black">Deseja realmente alterar o fim da vigência?</label>
          </div>
        </div>
        <br/>
        <div class="row">
          <div class="col-11">
            <label class="label-black">Motivo:</label>
            <span>{{objeto.motivo}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-11">
            <label class="label-black">Início Vigência:</label>
            <span>{{objeto.data_inicio_vigencia | formatDateMonthYear}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-11">
            <label class="label-black">Fim Vigência:</label>
            <span>{{objeto.data_fim_vigencia | formatDateMonthYear}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label class="col-form-label-sm label-input label-black" for="fimVigencia">Novo Fim Vigência:</label>
            <input
              class="form-control form-control-sm"
              v-mask="'##/####'"
              id="'fimVigencia'"
              v-model="objeto.novaDataFimVigencia"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-danger" @click="closeModalEdit()">
        <li class="oi oi-circle-x"></li> Não
      </button>
      <button class="btn btn-secondary" @click="editarObjeto()">
        <li class="oi oi-check"></li> Sim
      </button>
      </div>
    </modal>
  </div>
</template>

<script>
import money from "../../utils/InputMoney";
import competencia from "../../utils/InputCompetencia";
import cnpj from "../../utils/InputCnpj";
import http from "./../../../axios";
import modal from "../../utils/Modal";
import { mask } from "vue-the-mask";

export default {
  name: "LicencaPrevidenciariaListaDetalhada",
  components: {
    money: money,
    competencia: competencia,
    cnpj: cnpj,
    modal: modal
  },
  data() {
    return {
      listaObjeto: [],
      listaObjetoInsert: [],
      listaObjetoDelete: [],
      isModalVisible: false,
      isModalVisibleEdit: false,
      carregando: false,      
      showErrors: false,
      erros: [],
      msgSuccess: [],
      objeto: {},
      tokens: {},
      tabSelecionado: "inserido"
    };
  },
  directives: { mask },
  created: function() {
    this.getTokens();
    this.getListaObjeto();
  },
  methods: {
    tab: function(selecionado){
      this.tabSelecionado = selecionado;
      if(this.tabSelecionado == "inserido"){
        this.listaObjeto = this.listaObjetoInsert;
      }else{
        this.listaObjeto = this.listaObjetoDelete;
      }
    },
    showModal(objetoTemp) {
      this.objeto = { };
      this.objeto = objetoTemp;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    showModalEdit(objetoTemp) {
      this.objeto = { };
      this.objeto = objetoTemp;
      this.objeto.novaDataFimVigencia = "";
      this.isModalVisibleEdit = true;
    },
    closeModalEdit() {
      this.isModalVisibleEdit = false;
    },
    getListaObjeto: function() {
      this.$Progress.start();
      this.listaObjeto = [];
      this.listaObjetoInsert = [];
      this.listaObjetoDelete = [];
      http
        .get(`api/cooperado/${this.tokens.id}/licenca/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            for(var i = 0; i < r.data.result.length; i++){
              if(r.data.result[i].situacao == "Removido"){
                this.listaObjetoDelete.push(r.data.result[i]);
              }else{
                this.listaObjetoInsert.push(r.data.result[i]);
              }
            }
            if(this.tabSelecionado == "inserido"){
              this.listaObjeto = this.listaObjetoInsert;
            }else{
              this.listaObjeto = this.listaObjetoDelete;
            }
          } else {
            this.listaObjeto = [];
            this.listaObjetoInsert = [];
            this.listaObjetoDelete = [];
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
    deletarObjeto: function() {
      this.msgSuccess = [];
      this.closeModal()
      this.$Progress.start();
        http
          .delete(`api/cooperado/${this.tokens.id}/licenca/${this.objeto.id}`, {
            headers: { "token-cooperado-api": this.tokens.token }
          })
          .then(r => {
            if (r.data.statusCode == 200) {
              this.msgSuccess.push("Licença deletada com sucesso!");
              this.$Progress.finish()
              this.getListaObjeto();
            }
          })
          .catch(error => {
            this.$Progress.fail()
            if (error.response) {
              if (error.response.status >= 500) {
                this.$router.push("/");
              }else{
                this.$router.push("/LicencaPrevidenciariaLista");
              }
            } else if (error.request) {
                this.$router.push("/");
            } else {
              console.log("Error", error.message);
                this.$router.push("/");
            }
          });
    },
    
    editarAntes: function() {
      this.showErrors = false;
      this.erros = [];

        if (
          this.objeto.novaDataFimVigencia == "" &&
          this.objeto.novaDataFimVigencia.length == 0
        ) {
          this.erros.push("Novo Fim Vigência não informado");
        } else {
          if (!this.dataValida(this.objeto.novaDataFimVigencia)) {
            this.erros.push("Novo Fim Vigência inválido");
          }
        }
    },
    
    dataValida: function(data) {
      var valido = false;
      try {
        if (data != undefined && data.length == 7) {
          const mes = data.substring(0, 2);
          const ano = data.substring(3, 7);
          if (parseInt(mes) >= 1 && parseInt(mes) <= 12) {
            if (parseInt(ano) >= 1900 && parseInt(ano) <= 2100) {
              valido = true;
            }
          }
        }
      } catch (e) {
        valido = false;
      }
      return valido;
    },
    
    editarObjeto: function() {
      this.erros = [];
      this.msgSuccess = [];
      this.closeModalEdit()
      this.$Progress.start();
      this.editarAntes();
      if(this.erros.length == 0){
      var objetoUpdateVigencia = {
          licenca: this.objeto.id,
          cooperado: this.tokens.id,
          dataInicioVigencia: this.objeto.data_inicio_vigencia, 
          dataFimVigencia : this.dataFimFormatJson,
        };
        http
          .post(`/api/cooperado/licenca/vigencia/update`, objetoUpdateVigencia, {
            headers: { "token-cooperado-api": this.tokens.token }
          })
          .then(r => {
            if (r.data.statusCode == 200) {
              this.msgSuccess.push("Licença alterada com sucesso!");
              this.$Progress.finish()
              this.getListaObjeto();
            }
          })
          .catch(error => {
            this.$Progress.fail()
            if (error.response) {
              if (error.response.status >= 500) {
                this.$router.push("/");
              } else {
                if (error.response.status == 400) {
                  this.erros.push(error.response.data.result);
                }
              }
            } else if (error.request) {
              this.$router.push("/");
            } else {
              console.log("Error", error.message);
              this.$router.push("/");
            }
          });
          
      }else{
        this.$Progress.fail();
      }
    },
    getTokens: function() {
      this.tokens = this.$cooperadowebapi.tokens.get("usuario");
    }
  },
  computed: {
    dataFimFormatJson: function() {
      const mes = this.objeto.novaDataFimVigencia.substring(0, 2);
      const ano = this.objeto.novaDataFimVigencia.substring(3, 7);
      return ano + "-" + mes + "-01";
    },
    
    dataInicioFormatJson: function() {
      const mes = this.objeto.novaDataFimVigencia.substring(0, 2);
      const ano = this.objeto.novaDataFimVigencia.substring(3, 7);
      return ano + "-" + mes + "-01";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/licencaPrevidenciaria/LicencaPrevidenciariaListaDetalhada.vue